export const NOOP: (...args: any) => void = () => { /* do nothing */ }
